import { useCallback, useMemo } from "react";
import { FIELD_NAMES } from "./AskAQuestion.constanst";
import { FormikHelpers } from "formik";
import { ValuesType } from "./AskAQuestion.types";
import { sendEmailToSupport } from "./AskAQuestion.requests";

export function useInitialState() {
  return useMemo(() => {
    return {
      [FIELD_NAMES.NAME]: '',
      [FIELD_NAMES.EMAIL]: '',
      [FIELD_NAMES.QUESTION]: '',
      [FIELD_NAMES.URGENCY]: '',
    };
  }, []);
}

export function useSubmitHandler(onHide: () => void) {
  return useCallback(
    async (values: ValuesType, form: FormikHelpers<ValuesType>) => {
      try {
        form.setStatus({ loading: true });

        await sendEmailToSupport(values.name, values.email, values.question, values.urgency)
          .then(() => {
            form.setStatus({ loading: false });
            onHide();
          })
          .then(() => {
            form.setStatus({ loading: false });
          });

      } catch (err: any) {
        form.setStatus({ loading: false });
      }
    },
    [onHide]
  );
}
